"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import { areEqualAddresses, formatStatFloor } from "@/helpers/Helpers";
import type { ApiWallet } from "@/generated/models/ApiWallet";
export default function UserSettingsPrimaryWalletItem(t0) {
  const $ = _c(20);
  const {
    wallet,
    selected,
    onSelect
  } = t0;
  let t1;
  if ($[0] !== selected || $[1] !== wallet.wallet) {
    t1 = areEqualAddresses(wallet.wallet, selected);
    $[0] = selected;
    $[1] = wallet.wallet;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const [isActive, setIsActive] = useState(t1);
  let t2;
  let t3;
  if ($[3] !== selected || $[4] !== wallet.wallet) {
    t2 = () => {
      setIsActive(areEqualAddresses(wallet.wallet, selected));
    };
    t3 = [selected, wallet.wallet];
    $[3] = selected;
    $[4] = wallet.wallet;
    $[5] = t2;
    $[6] = t3;
  } else {
    t2 = $[5];
    t3 = $[6];
  }
  useEffect(t2, t3);
  let t4;
  if ($[7] !== onSelect || $[8] !== wallet.wallet) {
    t4 = () => onSelect(wallet.wallet);
    $[7] = onSelect;
    $[8] = wallet.wallet;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== wallet.tdh) {
    t5 = wallet.tdh > 0 ? formatStatFloor(wallet.tdh) : 0;
    $[10] = wallet.tdh;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const t6 = `${wallet.display ?? wallet.wallet} - ${t5}TDH`;
  let t7;
  if ($[12] !== t6) {
    t7 = <span className="tw-inline-block tw-text-sm tw-font-medium tw-text-white">{t6}</span>;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== isActive) {
    t8 = isActive && <svg className="tw-h-5 tw-w-5 tw-ml-2 tw-text-primary-300 tw-transition tw-duration-300 tw-ease-out" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20 6L9 17L4 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>;
    $[14] = isActive;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t4 || $[17] !== t7 || $[18] !== t8) {
    t9 = <li onClick={t4} className="tw-group tw-text-white tw-justify-between tw-w-full tw-flex tw-rounded-lg tw-relative tw-cursor-pointer tw-select-none tw-p-2 hover:tw-bg-iron-700 tw-transition tw-duration-300 tw-ease-out">{t7}{t8}</li>;
    $[16] = t4;
    $[17] = t7;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  return t9;
}